import type { SVGProps } from "react";

const SvgFlagNL = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="18"
        height="18"
        viewBox="0 0 4.76 4.76"
        {...props}
    >
        <defs>
            <circle id="a" cx="9" cy="9" r="9" />
        </defs>
        <g fillRule="evenodd" transform="scale(.26458)">
            <mask id="b" fill="#fff">
                <use width="100%" height="100%" xlinkHref="#a" />
            </mask>
            <use width="100%" height="100%" fill="#fff" xlinkHref="#a" />
            <path fill="#d0021b" d="M0 0h20v6H0z" mask="url(#b)" />
            <path fill="#1d77bf" d="M0 12h20v6H0z" mask="url(#b)" />
        </g>
    </svg>
);

export default SvgFlagNL;
